<template>
  <div class="form-item-box">
    <label class="form-item-label">
      {{ label }}
    </label>
    <div class="relative">
      <select class="form-item-select" v-model="model" :disabled="disabled">
        <option value="" v-if="includeNotSelected">{{$t('text.all')}}</option>
        <option v-for="(option, index) in options" :key="index" :value="option[keyField || 'id']">{{translate? $t(option[labelField || 'name']):option[labelField || 'name'] }}</option>
      </select>
    </div>
    <p v-if="errorMessage" class="form-error-text">{{ errorMessage }}</p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "BSelect",
    props: {
      label: {type: String, required: true},
      includeNotSelected: {type: Boolean, default: false},
      errorMessage: String,
      keyField: String,
      labelField: String,
      disabled: {type: Boolean, default: false},
      options: {type: Array, required: true},
      modelValue: {type: [String, Number], default: ''},
      translate:{type:Boolean}
    },
    emits: ['update:modelValue', 'change'],
    computed: {
      model: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
          this.$emit('change', value);
        }
      }
    },
  });
</script>